

import { Injectable } from '@angular/core'
import { Location } from '@angular/common'
import { Router, NavigationEnd, NavigationExtras } from '@angular/router'

@Injectable({ providedIn: 'root' })
export class NavigationService {
  private history: string[] = []

  constructor(
    private router: Router, 
    private location: Location) {
    this.router.events.subscribe((event) => {

      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects)
      }
    })
  }

  back(): void {

    if (this.history.length > 0) {
      this.location.back()
    } else {
      this.router.navigateByUrl('/')
    }
  }

  navigateTo(route:string, extras?: any): void {
      this.router.navigate([route], extras);
  }

  getHistory(): string[] {
    return this.history
  }
}